import React from 'react';
import InputSearch from '../../components/InputSearch';

const SearchBar = ({ inputs }) => {
  return (
    <div className="flex gap-4 mt-4 flex-wrap">
      {inputs.map((input, index) => {
        return <InputSearch className={'w-full min-[500px]:w-auto'} key={index} {...input} showReset={true} />;
      })}
    </div>
  );
};

export default SearchBar;
